/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MeResponseDto } from './MeResponseDto';
import {
    MeResponseDtoFromJSON,
    MeResponseDtoFromJSONTyped,
    MeResponseDtoToJSON,
    MeResponseDtoToJSONTyped,
} from './MeResponseDto';
import type { InsuredResponseDto } from './InsuredResponseDto';
import {
    InsuredResponseDtoFromJSON,
    InsuredResponseDtoFromJSONTyped,
    InsuredResponseDtoToJSON,
    InsuredResponseDtoToJSONTyped,
} from './InsuredResponseDto';

/**
 * 
 * @export
 * @interface ClaimResponseDto
 */
export interface ClaimResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ClaimResponseDto
     */
    claimId: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponseDto
     */
    insuredId: string;
    /**
     * 
     * @type {Date}
     * @memberof ClaimResponseDto
     */
    dateOfLoss: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClaimResponseDto
     */
    dateReported: Date;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponseDto
     */
    claimsHandler: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponseDto
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponseDto
     */
    causeOfLoss: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponseDto
     */
    catCode: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponseDto
     */
    subClass: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponseDto
     */
    lossLocation?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponseDto
     */
    status: ClaimResponseDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponseDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponseDto
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponseDto
     */
    lossDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponseDto
     */
    lineOfBusiness: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponseDto
     */
    paymentsOurShare: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponseDto
     */
    outstandingOurShare: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponseDto
     */
    incurredOurShare: string;
    /**
     * 
     * @type {InsuredResponseDto}
     * @memberof ClaimResponseDto
     */
    insured?: InsuredResponseDto;
    /**
     * 
     * @type {MeResponseDto}
     * @memberof ClaimResponseDto
     */
    claimsHandlerUser?: MeResponseDto;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponseDto
     */
    legacyClaimNo?: string;
}


/**
 * @export
 */
export const ClaimResponseDtoStatusEnum = {
    PreCautionary: 'Pre-cautionary',
    Registered: 'Registered',
    InProgress: 'In-progress',
    Closed: 'Closed'
} as const;
export type ClaimResponseDtoStatusEnum = typeof ClaimResponseDtoStatusEnum[keyof typeof ClaimResponseDtoStatusEnum];


/**
 * Check if a given object implements the ClaimResponseDto interface.
 */
export function instanceOfClaimResponseDto(value: object): value is ClaimResponseDto {
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('insuredId' in value) || value['insuredId'] === undefined) return false;
    if (!('dateOfLoss' in value) || value['dateOfLoss'] === undefined) return false;
    if (!('dateReported' in value) || value['dateReported'] === undefined) return false;
    if (!('claimsHandler' in value) || value['claimsHandler'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('causeOfLoss' in value) || value['causeOfLoss'] === undefined) return false;
    if (!('catCode' in value) || value['catCode'] === undefined) return false;
    if (!('subClass' in value) || value['subClass'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('lineOfBusiness' in value) || value['lineOfBusiness'] === undefined) return false;
    if (!('paymentsOurShare' in value) || value['paymentsOurShare'] === undefined) return false;
    if (!('outstandingOurShare' in value) || value['outstandingOurShare'] === undefined) return false;
    if (!('incurredOurShare' in value) || value['incurredOurShare'] === undefined) return false;
    return true;
}

export function ClaimResponseDtoFromJSON(json: any): ClaimResponseDto {
    return ClaimResponseDtoFromJSONTyped(json, false);
}

export function ClaimResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'claimId': json['claimId'],
        'insuredId': json['insuredId'],
        'dateOfLoss': (new Date(json['dateOfLoss'])),
        'dateReported': (new Date(json['dateReported'])),
        'claimsHandler': json['claimsHandler'],
        'currency': json['currency'],
        'causeOfLoss': json['causeOfLoss'],
        'catCode': json['catCode'],
        'subClass': json['subClass'],
        'lossLocation': json['lossLocation'] == null ? undefined : json['lossLocation'],
        'status': json['status'],
        'city': json['city'],
        'country': json['country'],
        'lossDescription': json['lossDescription'] == null ? undefined : json['lossDescription'],
        'lineOfBusiness': json['lineOfBusiness'],
        'paymentsOurShare': json['paymentsOurShare'],
        'outstandingOurShare': json['outstandingOurShare'],
        'incurredOurShare': json['incurredOurShare'],
        'insured': json['insured'] == null ? undefined : InsuredResponseDtoFromJSON(json['insured']),
        'claimsHandlerUser': json['claimsHandlerUser'] == null ? undefined : MeResponseDtoFromJSON(json['claimsHandlerUser']),
        'legacyClaimNo': json['legacyClaimNo'] == null ? undefined : json['legacyClaimNo'],
    };
}

export function ClaimResponseDtoToJSON(json: any): ClaimResponseDto {
    return ClaimResponseDtoToJSONTyped(json, false);
}

export function ClaimResponseDtoToJSONTyped(value?: ClaimResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimId': value['claimId'],
        'insuredId': value['insuredId'],
        'dateOfLoss': ((value['dateOfLoss']).toISOString()),
        'dateReported': ((value['dateReported']).toISOString()),
        'claimsHandler': value['claimsHandler'],
        'currency': value['currency'],
        'causeOfLoss': value['causeOfLoss'],
        'catCode': value['catCode'],
        'subClass': value['subClass'],
        'lossLocation': value['lossLocation'],
        'status': value['status'],
        'city': value['city'],
        'country': value['country'],
        'lossDescription': value['lossDescription'],
        'lineOfBusiness': value['lineOfBusiness'],
        'paymentsOurShare': value['paymentsOurShare'],
        'outstandingOurShare': value['outstandingOurShare'],
        'incurredOurShare': value['incurredOurShare'],
        'insured': InsuredResponseDtoToJSON(value['insured']),
        'claimsHandlerUser': MeResponseDtoToJSON(value['claimsHandlerUser']),
        'legacyClaimNo': value['legacyClaimNo'],
    };
}

